/**
 * Play-off bracket of the UEFA Nations League: the title rounds of League A.
 * Quarter-finals of a group runner-up against a group winner (two legs), then
 * semi-finals and a final of one match each.
 *
 * Which runner-up meets which winner is decided by a draw each season, so a
 * quarter-final slot names the two places and nothing more.
 */

import type { BracketRoundTemplate } from './types';
import { ranks, winnerOfSlot } from './uefaLeaguePhaseBracket';

export const UEFA_NATIONS_LEAGUE_BRACKET: BracketRoundTemplate[] = [
  { stage: 'Quarter-finals', legs: 2, slots: [1, 2, 3, 4].map(() => [ranks(2), ranks(1)]) },
  {
    stage: 'Semi-finals',
    legs: 1,
    slots: [
      [winnerOfSlot(0, 1), winnerOfSlot(0, 2)],
      [winnerOfSlot(0, 3), winnerOfSlot(0, 4)],
    ],
  },
  { stage: 'Final', legs: 1, slots: [[winnerOfSlot(1, 1), winnerOfSlot(1, 2)]] },
];
